module.exports = __webpack_public_path__ + "img/xinpzzx.50f2626d.svg";